export enum ProductSlug {
  Professional = 'professional',
  ProfessionalNew = 'professional-new'
}
